
import React, { Fragment } from 'react';
import { Button } from '@ui/buttons/button';
import { Trans } from '@ui/i18n/trans';
import { Link } from 'react-router-dom';
import imgUrl1 from './images/enveloppe.png';
import imgUrl2 from './images/blank.png';
import { useConsentType } from './requests/use-consent-type';
import { ProgressCircle } from '@ui/progress/progress-circle';
import { useArtist } from '@app/web-player/artists/requests/use-artist';

export default function UnsubscribeConfirmation() {
  const params = new URLSearchParams(window.location.search);
  const typeId = params.get('ti') ? Number(params.get('ti')) : null;
  const scopeType = params.get('st');
  const scopeId = params.get('si');

  const {data: consentType, isLoading: isLoadingConsentType} = useConsentType(typeId);
  const {data: artist, isLoading: isLoadingArtist} = useArtist({loader: "artist", artistId: scopeType === "artist" ? Number(scopeId) : 0});

  return (
    <div className="flex flex-col-reverse items-center justify-center gap-64 px-16 py-96 md:gap-112 md:px-176 md:py-80 lg:flex-row lg:px-96 lg:py-96">
      {isLoadingConsentType || (scopeType === "artist" && isLoadingArtist) ? (
        <ProgressCircle
          className="my-80"
          aria-label="Loading user.."
          isIndeterminate
        />
      ) : (
        <Fragment>
          <div className="relative w-full pb-48 lg:pb-0 xl:w-1/2 xl:pt-96">
            <div className="relative">
              <div className="absolute">
                <div className="relative z-10">
                  <h1 className="my-8 text-2xl font-bold text-main">
                    <Trans message="You have been unsubscribed from the selected email communications." />
                  </h1>
                  {consentType && (
                    <Fragment>
                      {(consentType.name || scopeType) && (
                        <div className="my-8 text-main">
                          {consentType.name && (
                            <p>
                              <Trans message="Communication type" />: <strong><Trans message={consentType.name} /></strong>
                            </p>
                          )}

                          {scopeType === "artist" && artist && (
                            <p className="my-16 text-xl">
                              <Trans message='This preference applies only to this specific artist' />: {artist.artist.name}
                            </p>
                          )}
                        </div>
                      )}
                    </Fragment>
                  )}
                  <p className="my-16 text-main">
                    <Trans message='You can update your preferences at any time.' />
                  </p>

                  <Button
                    className="my-8"
                    elementType={Link}
                    to="/user/account-settings"
                    variant="flat"
                    color="primary"
                  >
                    <Trans message="Manage my email preferences" />
                  </Button>
                </div>
              </div>
              <div className="dark:opacity-5">
                <img src={imgUrl2 as any ?? null} alt="" />
              </div>
            </div>
          </div>
          <div className="dark:opacity-80">
            <img src={imgUrl1 as any ?? null} alt="" />
          </div>
        </Fragment>
      )}
    </div>
  );
}
